import { apiClient } from "./client";

/**
 * Seniority Bands API functions
 * Manages tenant-level seniority bands configuration
 */
export const seniorityBandsApi = {
  /**
   * Get the seniority bands configuration for the current tenant
   */
  get: async () => {
    return apiClient.get("/senioritybands");
  },

  /**
   * Save the seniority bands configuration
   * @param {Array} bands - Array of seniority band objects
   */
  save: async (bands) => {
    return apiClient.put("/senioritybands", { bands });
  },

  /**
   * Reset seniority bands to default values
   */
  reset: async () => {
    return apiClient.post("/senioritybands/reset");
  },

  /**
   * Get the default seniority bands
   */
  getDefaults: async () => {
    return apiClient.get("/senioritybands/defaults");
  },
};

export default seniorityBandsApi;
